<div class="container">
  <div class="container__body">

  <div class="legal-entity-type-container">
    <div style="width: 100%; margin: 0px 20px 0px 0px">
      <span class="p-float-label">
        <dx-text-box
          id="float-input"
          [(value)]="newLegalEntity"
          [style]="{ width: '100%' }"
          (onInput)="enableButton()"
          placeholder="Type legal entity name here..."
          >
        </dx-text-box>
      </span>
    </div>
    <div style="width: 100%; margin: 0px 20px 0px 0px">
      <dx-select-box
              [dataSource]="businessNames$ | async"
              [(value)]="selectedParentEntityId"
              displayExpr= "legalEntityName"
              valueExpr="legalEntityId"
              [searchEnabled]="true"
              [showClearButton]="false"
              placeholder="Parent Legal Entity(Optional)"
              (onValueChanged)="enableButton()">
      </dx-select-box>
    </div>
  </div>
  <div class="legal-entity-name-container">
    <div class="legal-entity-types-container">
      <div class="legal-entity-type-card"
           *ngFor="let entityType of newCountryNameResults"
           [class.selected]="selectedCountryId === entityType.id"
           (click)="selectEntityType(entityType)">
        <div class="entity-icon">
          <i [class]="getEntityIcon(entityType.description)"></i>
        </div>
        <div class="entity-title">{{ entityType.description }}</div>
      </div>
    </div>
  </div>
  <div class="legal-entity-name-container">
    <div class="decision-container">
      <div class="fsp-decision-field">
        <div class="fsp-label">Asset Manager</div>
        <div class="fsp-radio-group">
          <dx-radio-group
            [items]="fspValues"
            valueExpr="id"
            layout="horizontal"
            displayExpr="valueText"
            [(value)]="selectionAssetManager"
          >
          </dx-radio-group>
        </div>
      </div>
      <div class="fsp-decision-field">
        <div class="fsp-label">Is this legal entity financially regulated (FSP)?</div>
        <div class="fsp-radio-group">
          <dx-radio-group
            id="radio-group-with-selection"
            [items]="fspValues"
            valueExpr="id"
            layout="horizontal"
            displayExpr="valueText"
            [(value)]="selectionFSP"
            (onValueChanged)="onFSPValueChanged($event)"
          >
          </dx-radio-group>
        </div>
      </div>
    </div>
  </div>
  <div class="legal-entity-type-container" *ngIf="showFSPInput">
    <div style="width: 100%">
      <span class="p-float-label">
        <dx-text-box
          id="float-input"
          [(value)]="fspNumber"
          maxLength="6"
          [style]="{ width: '100%' }"
          (onInput)="onFSPCHanged($event)"
          placeholder="FSP number (enter numbers only)"
          >
        </dx-text-box>
      </span>
    </div>
  </div>

  </div>

  <div class="buttons">
    <div>
      <dx-button
                    text="Cancel"
                    stylingMode="outlined"
                    type="default"
                    icon=""
                    (onClick)="cancelPopup()">
                </dx-button>
    </div>
    <div>
      <dx-button [disabled]="disableButton"
                    text="Add legal entity"
                    stylingMode="contained"
                    type="default"
                    icon=""
                    (onClick)="submitNewLegalEntity()">
                </dx-button>
    </div>
  </div>
</div>
